// Mirror of backend/constants/wfReportConfig.js — keep in sync.
export const INCEPTION_MONTH = '2024-04';           // first column of the Profit Sharing sheet
export const MONTH_RE = /^\d{4}-(0[1-9]|1[0-2])$/;
export const MONTH_NAMES = ['January','February','March','April','May','June','July','August','September','October','November','December'];
export const MONTH_SHORT = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

export const PNL_LINES = [
  { key: 'inc_venue',        section: 'income', label: 'Venue' },
  { key: 'inc_led',          section: 'income', label: 'LED and Audio' },
  { key: 'inc_deco',         section: 'income', label: 'Decoration' },
  { key: 'inc_caterer',      section: 'income', label: 'Caterer Charges' },
  { key: 'inc_addon',        section: 'income', label: 'Add On service' },
  { key: 'cogs_led',         section: 'cogs',   label: 'LED and Audio' },
  { key: 'cogs_wages',       section: 'cogs',   label: 'Wages' },
  { key: 'cogs_deco',        section: 'cogs',   label: 'Decoration' },
  { key: 'cogs_caterer',     section: 'cogs',   label: 'Caterer Charges' },
  { key: 'cogs_addon',       section: 'cogs',   label: 'Add On service' },
  { key: 'fx_salaries',      section: 'fixed',  label: 'Salaries' },
  { key: 'fx_marketing',     section: 'fixed',  label: 'Marketing fee' },
  { key: 'fx_rental',        section: 'fixed',  label: 'Rental' },
  { key: 'fx_utilities',     section: 'fixed',  label: 'Utilities' },
  { key: 'fx_subscriptions', section: 'fixed',  label: 'Subscriptions' },
  { key: 'fx_depreciation',  section: 'fixed',  label: 'Depreciation' },
  { key: 'fx_bank',          section: 'fixed',  label: 'Bank Charges' },
  { key: 'fx_upkeep',        section: 'fixed',  label: 'Upkeep of Factory' },
  { key: 'fx_misc',          section: 'fixed',  label: 'Miscellaneous' },
];
export const PNL_KEYS = PNL_LINES.map(l => l.key);

export const OPERATING_KEYS = ['events_private', 'events_wedding', 'events_corporate', 'enquiries',
  'site_visits', 'bookings_wedding', 'bookings_corporate', 'bookings_private', 'sales_value'];
// Counts must be non-negative integers; sales_value is money.
export const OPERATING_INT_KEYS = OPERATING_KEYS.filter(k => k !== 'sales_value');

export const DEAL_SEGMENTS = ['wedding', 'corporate', 'private'];
